import { isDefined } from '@vueuse/core'

import type { VTooltipOption } from './types'

export const getProps = (
  value: VTooltipOption['content'] | Partial<VTooltipOption>
): VTooltipOption => {
  if (typeof value === 'string') {
    return {
      content: value
    }
  }
  return {
    content: value.content ?? '',
    ...value
  }
}

export const setDataSet = (element: HTMLElement, value: VTooltipOption) => {
  const { content, placement = 'top', disabled = false, always = true, ...props } = value
  const vTooltipProps = {
    ...props,
    always,
    content,
    placement,
    disabled
  }
  element.dataset.vTooltip = ''
  element.dataset.vTooltipProps = JSON.stringify(vTooltipProps)
}
export const getTooltipPropsFromElement = (element: HTMLElement): VTooltipOption | null => {
  if (!isVTooltipElement(element)) {
    return null
  }
  try {
    return JSON.parse(element.dataset.vTooltipProps ?? '{}')
  } catch {
    /* empty */
  }
  return null
}

export function isVTooltipElement(element: Element): boolean {
  return isDefined((element as HTMLElement).dataset?.vTooltip)
}

export function isOverFlow(elem: HTMLElement) {
  return elem.scrollWidth > elem.offsetWidth
}
